import React from 'react';
import apiurl from "./apiurl";
import axios from "axios";
import swal from 'sweetalert';
import update from 'immutability-helper';
import Input from "./Input";
import SQRList from "./SQRList";
import { wymagane } from "./wymagane";
import Tabela from './Tabela';
import PrintComponents from "react-print-components";
import PrintTable from './PrintTable';


export default class SQR extends React.Component {
  constructor() {
    super();
    this.state={
      SQRPost: [],
      SQRFileList: [],
      loading: false,
      token: sessionStorage.getItem('token'),
    }

  }

  componentDidMount () {
    this.getSQRList()
  }

  getSQRList() {
    axios.get(apiurl+"api/Filesqr",
      {headers : {'Content-Type': 'application/json', 'Authorization' : "Bearer " + this.state.token} })
      .then(res => {
        this.setState({ SQRFileList : res.data })
      })
      .catch(error => {if(error.response.data.excepctionMessage) {swal(error.response.data.excepctionMessage)}
      this.setState({ loading: false }) } );
  }

  getSQR = (evt, sqrname) => {
    this.setState({ SQRData: [], SQRPost: [], loading: true });
    axios.get(apiurl+"api/Sqr",
      {headers : {'Content-Type': 'application/json', 'Authorization' : "Bearer " + this.state.token}, params: { sqrName: sqrname} })
      .then(res => {
        let newPOST = [];
        if(res.data.param.length > 0){
        res.data.param.map((elem) =>{
            newPOST.push({nazwa: elem.nazwa, value: null});
        });
        this.setState({ SQRData : res.data.param, SQRDesc : res.data,  keyToken: res.data.key, SQRPost: newPOST, loading: false });
      } else {
        this.setState({ keyToken: res.data.key, SQRPost : [], loading: false});
        this.PostSQR(evt);
      }
      })
      .catch(error => { 
        if(error.response.data.Message) {swal(error.response.data.Message)}; 
        this.setState({ loading: false }) });
  }

  onChangeRequired = (e, nazwa, value) => {
    const { SQRData } = this.state;
    SQRData.map((data, idx) => {
      if(data.requiredFields.length > 0) {
        data.requiredFields.map((data) => {
          if(data === nazwa) {
            this.RequiredPUT(e, nazwa, e.target.value);
          }
        });
      } else {
        return null
      }
    });

    this.onChangeInput(nazwa, 'value', value);
    
  }

  RequiredPUT = (evt, nazwaPola, value ) => {
    evt.preventDefault();
    axios.put(apiurl+"api/Sqr",
        { key: this.state.keyToken, nazwa: nazwaPola, value: value},
        {headers : {'Authorization' : "Bearer " + this.state.token } } )
        .then(res => {
          this.updatePolaRequired(res.data.nazwa, res.data.param)
        })
    .catch(error => swal(error.response.data.Message));
  }

  updatePolaRequired = (nazwa, opcje) => {
    const { SQRData } = this.state;

    let index = SQRData.findIndex( element => element.nazwa === nazwa )

    const updatedComment = update(SQRData[index], {param: {$set: opcje}}); 
  
    var newData = update(SQRData, {
        $splice: [[index, 1, updatedComment]]
    });
    
    this.setState({SQRData: newData});
  }

  onChangeInput = (nazwa, name, value) => {
    const data = this.state.SQRPost;
    let index = data.findIndex( element => element.nazwa === nazwa )

    const updatedComment = update(data[index], {[name]: {$set: value}}); 
  
    var newData = update(data, {
        $splice: [[index, 1, updatedComment]]
    });
    this.setState({SQRPost: newData});
  }

  onChangeMulti = (nazwa, value) => {
    let wybrane = []
    value.map((elem) =>{
      wybrane.push(elem.id);
    });

    let end = wybrane.toString();
    this.onChangeInput(nazwa, 'value', end)
    console.log(end)
  }

  PostSQR = (e) => {
    e.preventDefault();
    this.setState({ loading: true })
    axios.post(apiurl+"api/Sqr", { 
      key: this.state.keyToken,
      lista: this.state.SQRPost
    } ,
    {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
    .then(res => {
      this.setState({dataTable: res.data, loading: false })
    })
    .catch(error => { 
      if(error.response.data.Message) {swal(error.response.data.Message)}; 
      this.setState({ loading: false }) });

  }

  downloadCSVFromJson = (filename, arrayOfJson, headers) => {
    const replacer = (key, value) => value === null ? '' : value 
    const header = Object.keys(arrayOfJson[0])
    let csv = arrayOfJson.map(row => header.map(fieldName => 
    JSON.stringify(row[fieldName], replacer)).join(';'))
    csv.unshift(headers.join(';'))
    csv = csv.join('\r\n')

    var link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  };

render() {

let { SQRData, SQRFileList, SQRDesc, loading, dataTable } = this.state;

// if(dataTable) {
//   return <Redirect
//   to={{
//   pathname: "/SQRData",
//   state: { 
//     headers: dataTable.headers,
//     body: dataTable.data,
//    }
//   }}
//   />
// }


if(dataTable) {
  return (<React.Fragment>
  <div className="d-flex flex-column p-4 w-100">
  <div className="d-flex flex-row mt-2">
  <button className="btn btn-light m-2" onClick={() => (this.setState({ dataTable: null }))}>Wróc</button>
  <PrintComponents trigger={<button className="btn btn-light m-2 ml-auto"><i class="fas fa-print"></i> Drukuj</button>} >
    <PrintTable headers={dataTable.headers} body={dataTable.data} header={dataTable.header} headerExt={dataTable.headerExt} footer={dataTable.footer} />
  </PrintComponents>
  <button type="button" className="btn btn-light m-2" onClick={() => (this.downloadCSVFromJson('Eksport.csv', dataTable.data, dataTable.headers))}><i class="fas fa-file-csv"></i> Pobierz dane</button>
  </div>
  <div className="d-flex flex-row mt-3 justify-content-center">
  <Tabela headers={dataTable.headers} body={dataTable.data} header={dataTable.header} headerExt={dataTable.headerExt} footer={dataTable.footer} />
  </div>
  </div>
  </React.Fragment>)
}

return (
  <React.Fragment>
    <div className="container-fluid d-flex justify-content-around">
                
      <div className="flex-column mt-5 mb-5">
      
        {SQRFileList ? <SQRList data={SQRFileList} nameLast={''} getSQR={this.getSQR}/> : null }

      </div>

      <div className="flex-column w-50 mt-5">
      {loading ? (<div className="d-flex justify-content-center w-100">
        <div className="spinner-border text-primary mt-5 mb-3" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
      ) : null}

      {SQRDesc ? (<div className="d-flex flex-column">
        {SQRDesc.Name ? (<div className="d-flex flex-row mb-2">
          <b>{SQRDesc.name}</b>
        </div>) : null}
        {SQRDesc.Comment ? (<div className="d-flex flex-row mb-2">
          <span>{SQRDesc.comment}</span>
        </div>) : null}
      </div>) : null}

      {SQRData ? (SQRData.map((data, index) => {
      return (<>
        <Input 
        key={index} 
        idx={index} 
        onChangeRequired={this.onChangeRequired}
        onChangeInput={this.onChangeInput}
        onChangeMulti={this.onChangeMulti}
        type={data.typ} 
        rodzaj={data.rodzaj}
        longname={data.longName} 
        nazwa={data.nazwa} 
        params={data.param}
        Optional={data.optional} 
        RequiredFields={data.requiredFields}
        wymagane={wymagane(data.requiredFields, SQRData)} />
      </>);
      }) ) : null }

      {SQRData && SQRData.length > 0 ? (
        <button className="btn btn-success float-right mt-3" onClick={(e) => (this.PostSQR(e))}>Zapisz</button>
      ) : null }
      </div>

    </div>
    
    

  </React.Fragment>
)
  }
}

